import React from 'react';
import { Layout } from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';
import { motion } from 'framer-motion';
import { User, Mail, Crown, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function ProfilePage() {
  const { user } = useAuth();

  return (
    <Layout>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="p-4 md:p-8 max-w-4xl mx-auto"
      >
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Meu Perfil
          </h1>
          <p className="text-muted-foreground text-lg">Gerencie suas informações</p>
        </div>

        <div className="grid gap-6">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="p-8 rounded-2xl bg-white border border-border"
          >
            <div className="flex items-center gap-6 mb-8">
              <div className="h-20 w-20 rounded-2xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white text-2xl font-bold">
                {user?.nome?.charAt(0).toUpperCase()}
              </div>
              <div>
                <h2 className="text-2xl font-bold mb-1">{user?.nome}</h2>
                <p className="text-muted-foreground">{user?.email}</p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3 p-4 rounded-xl bg-muted">
                <User className="h-5 w-5 text-primary" />
                <div>
                  <p className="text-sm text-muted-foreground">Nome</p>
                  <p className="font-medium">{user?.nome}</p>
                </div>
              </div>

              <div className="flex items-center gap-3 p-4 rounded-xl bg-muted">
                <Mail className="h-5 w-5 text-primary" />
                <div>
                  <p className="text-sm text-muted-foreground">Email</p>
                  <p className="font-medium">{user?.email}</p>
                </div>
              </div>

              <div className="flex items-center gap-3 p-4 rounded-xl bg-muted">
                <Crown className="h-5 w-5 text-primary" />
                <div>
                  <p className="text-sm text-muted-foreground">Plano</p>
                  <p className="font-medium">{user?.plan === 'PREMIUM' ? 'Premium' : 'Grátis'}</p>
                </div>
              </div>
            </div>
          </motion.div>

          {user?.plan !== 'PREMIUM' && (
            <Link to="/upgrade">
              <motion.div
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.1 }}
                data-testid="profile-upgrade-cta"
                className="p-6 rounded-2xl bg-gradient-to-r from-primary to-secondary text-white cursor-pointer hover:opacity-90 transition-opacity"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold mb-1">Upgrade para Premium</h3>
                    <p className="text-white/90">Desbloqueie todo o conteúdo</p>
                  </div>
                  <Crown className="h-12 w-12" />
                </div>
              </motion.div>
            </Link>
          )}
        </div>
      </motion.div>
    </Layout>
  );
}
